import React, { SVGProps } from 'react';

const SvgFleetIntelligenceAi = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M19.68 11.6211C21.1835 8.62998 21.3376 5.78124 19.7991 4.24265C17.4559 1.89955 12.074 3.48245 7.77824 7.77825C7.41089 8.14559 7.06337 8.52088 6.73646 8.90154M4.51656 12.1211C2.87047 15.2204 2.65286 18.2092 4.2427 19.799C5.84611 21.4025 8.87247 21.1674 12 19.4827C13.4429 18.7055 14.9073 17.6197 16.2635 16.2635C16.7047 15.8223 17.1173 15.3696 17.5 14.9099" stroke="url(#paint0_linear_6196_261)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.2635 7.77824C20.5593 12.074 22.1422 17.4559 19.7991 19.7991C17.4559 22.1422 12.074 20.5593 7.77824 16.2635C3.48247 11.9678 1.89956 6.58585 4.2427 4.2427C6.58585 1.89956 11.9678 3.48247 16.2635 7.77824Z" stroke="url(#paint1_linear_6196_261)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_6196_261" x1="3.15918" y1="12.0209" x2="20.8826" y2="12.0209" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#0BB4F1" />
                    <stop offset="0.216346" stop-color="#00D3CF" />
                    <stop offset="0.408654" stop-color="#2C55BA" />
                    <stop offset="0.673077" stop-color="#5D2CA4" />
                    <stop offset="0.990385" stop-color="#F00D69" />
                </linearGradient>
                <linearGradient id="paint1_linear_6196_261" x1="12.0209" y1="3.15918" x2="12.0209" y2="20.8826" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#0BB4F1" />
                    <stop offset="0.216346" stop-color="#00D3CF" />
                    <stop offset="0.408654" stop-color="#2C55BA" />
                    <stop offset="0.673077" stop-color="#5D2CA4" />
                    <stop offset="0.990385" stop-color="#F00D69" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default SvgFleetIntelligenceAi;


